import eventHub from "../eventHub";

export default {
    data() {
        return {
            modal_message: '',
            keys_for_deletion : {},
            data_key_field : 'code',
            delete_url : '',
            select_all: false,
            row_checkbox: [],
        }
    },
    beforeDestroy() {
        eventHub.$off('confirm-deletion', this.confirmDeletion);
    },
    mounted() {
        eventHub.$on('confirm-deletion', this.confirmDeletion)
    },
    methods : {
        /**
         * Delete function of delete button on the list.
         * ie. @click="confirmDeletion(key)"  key is the data of data_key_field eg. (code, id etc.)
         *
         * Current support single deletion.
         * TODO - to allow multiple deletion.
         *
         */
        confirmDeletion(delete_key) {
            let key = delete_key;

            if(typeof delete_key === 'object') {
                key = delete_key.key;

                if(key === 'by_checkbox') {
                    this.delete_url = delete_key.delete_url;
                    this.keys_for_deletion = this.row_checkbox;
                    if(delete_key.msg) {
                        this.modal_message = delete_key.msg;
                    }
                    return;
                } else {
                    if(delete_key.msg) {
                        this.modal_message = delete_key.msg;
                    }
                    this.data_key_field = (delete_key.data_key_field) ? delete_key.data_key_field : 'code';
                }
            }
            this.setDeleteUrl(key);
            this.keys_for_deletion = {};
            this.keys_for_deletion[key] = key;

            return;
        },
        setDeleteUrl(key) {
            let self = this;
            _.each(self.table_data.data, function (record) {
                if(record[self.data_key_field] == key) {
                    self.delete_url = record.delete_url;
                }
            });
        },
        /**
         * Delete function of modal submit button.
         * ie. @click="deleteRecord"
         *
         * Supported parsing array through request to server side.
         */
        deleteRecord() {
			let self = this;
			let formData = { keys_for_deletion : this.keys_for_deletion }
			let ajaxSuccessCallback = (response) => {
				this.$nextTick(function() {
					// self.table_data = response.data;
					eventHub.$emit('plain-list-reload-data'); // For PlainListing
					eventHub.$emit('list-reload-data'); // For Table
					this.$refs.ListModal.toggle();
					this.$store.commit('setNotificationType', 'success');
					this.$store.commit('setNotification', response.data.msg);
				});
			};
			let ajaxFailCallback = (error) => {
				self.$refs.ListModal.toggle();
				self.$store.commit('setNotificationType', 'danger');
				self.$store.commit('setNotification', error.response.data.msg);
			};
			this.$root.ajax_delete(this.delete_url, formData, ajaxSuccessCallback, ajaxFailCallback, true);
        },

    },
    computed : {
        modal_lang() {
            return this.$store.getters.lang;
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/deleteModal.js